<template>
  <div id="jumbotron">
    <div class="container">
      <h1>Our Programs<br>for all ages</h1>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          1. English Language Programs
        </h2>
        
        <p>
          Our core English programs continue to focus on:
        </p>

        <ul>
          <li><strong>General English</strong> - Improve your everyday communication skills.</li>
          <li><strong>Business English</strong> - Gain confidence in corporate communication.</li>
          <li><strong>Cambridge Exam Preparation (FCE, CAE, CPE)</strong> - Structured courses to prepare students for internationally recognized English proficiency certifications.</li>
          <li><strong>IELTS & TOEFL Preparation</strong> - Achieve your desired scores for academic and professional advancement.</li>
          <li><strong>English for Young Learners</strong> - Interactive lessons for children and teenagers</li>
          <li><strong>Reading & Writing Enhancement</strong> - Strengthen literacy skills, creative writing, and academic writing techniques.</li>
        </ul>

        <router-link class="btn btn-secondary me-4 px-4" to="/english-classes">Learn More</router-link>
      </div>
    </div>
  </div>

  <div class="bg-color">
    <div class="container py-5 my-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            2. New Language Offerings
          </h2>
          <p>
            To cater to a broader audience, we are excited to introduce <strong>French, Mandarin, and German courses</strong>! Whether you are learning for travel, business, or personal growth, our structured programs ensure rapid progress with native-speaking instructors.
          </p>
          <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/79" target="_blank">Learn More</a>
        </div> 
      </div>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-6">
        <h2 class="text-primary mb-4">
          3. Personal Development Program (PDP) by Edumind
        </h2>
        <p>
          In collaboration with Edumind, we offer the Personal Development Program (PDP), designed for students aged 12-21. This program enhances essential life skills, including:
        </p>
        <ul>
          <li>Whole Brain Learning & Study Techniques</li>
          <li>Critical & Creative Thinking</li>
          <li>Leadership & Teamwork</li>
          <li>Communication & Public Speaking</li>
          <li>Time & Stress Management</li>
        </ul>
        <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/77" target="_blank">Learn More</a>
      </div>
      <div class="col-12 col-md-6">
        <div class="row m-0 pt-5">
          <div class="col-6">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/whale+room+01.jpeg" alt="Whale Room" class="w-100">
          </div>
          <div class="col-6">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/whale+room+02.jpeg" alt="Whale Room" class="w-100">
          </div>
          <div class="col-12 text-center pt-2">
            <p>Whale Room</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-color">
    <div class="container py-5 my-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            4. Hybrid IGCSE Program (by Edumind)
          </h2>
          <p>
            For students seeking a globally recognized qualification at an affordable price, explore our <strong>IGCSE / A-levels / Tuition / Exam Prep Program</strong>. Taught by mostly native English-speaking teachers, this program blends online flexibility with in-person support. Call us or (Learn more at <a href="https://www.edumind.com.my" target="_blank">www.edumind.com.my</a>)
          </p>
          <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/81" target="_blank">Learn More</a>
        </div> 
      </div>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          5. School Holiday Camps (Enquire now)
        </h2>
        <p>
          Sitting around bored or playing computer/mobile games throughout your holidays? Why not GET out and about, this is the opportune time to increase your skills! 
        </p>
        <p>
          We offer exciting school holiday camps designed to enhance students’ learning in a fun and engaging environment. These camps focus on language immersion, leadership skills, teamwork, and creative problem-solving through interactive activities and real-world projects. Ideal for students looking to boost their confidence while making new friends!
        </p>
        <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/83" target="_blank">Learn More</a>
      </div>
    </div>
  </div>
  <br><br><br>
  <WhyUs />
  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 1.8em; }
h3 { font-size: 1.5em; }

.bg-color {
  background-color: #F4F3F9;
}

ul.style-type-none {
  list-style-type: none;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
import WhyUs from '../components/WhyUs.vue';
export default {
  components: { ContactUs, WhyUs }
}
</script>